import { render, staticRenderFns } from "./Fruits.vue?vue&type=template&id=47f027c4"
import script from "./Fruits.vue?vue&type=script&lang=js"
export * from "./Fruits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports